import { UmssHasPermissionDirective } from '../../directives/has-permission.directive';
import {
  Component,
  computed,
  inject,
  input,
  output,
  signal
} from '@angular/core';
import { UmssButtonComponent } from '../button/button.component';
import { Permission } from '@umss/shared/data-access';
import { BreakpointService } from '../../services/breakpoint.service';
import { UmssIconButtonComponent } from '../icon-button/icon-button.component';
import { UmssDialogComponent } from '../dialog/dialog.component';
import { UmssDialogHeaderComponent } from '../dialog-header/dialog-header.component';
import { UmssTooltipDirective } from '../../directives/tooltip.directive';

@Component({
  selector: 'umss-page-header',
  standalone: true,
  imports: [
    UmssButtonComponent,
    UmssHasPermissionDirective,
    UmssIconButtonComponent,
    UmssDialogComponent,
    UmssDialogHeaderComponent,
    UmssTooltipDirective
  ],
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.scss']
})
export class UmssPageHeaderComponent {
  title = input('');
  description = input<string>();
  showDescription = input(false);
  showButton = input(false);
  buttonText = input('Add');
  buttonIcon = input<string>();
  buttonVariant = input<'Primary' | 'Secondary'>('Primary');
  buttonSize = input<'Small' | 'Regular' | 'Large'>('Small');
  disabledButton = input(false);
  permissions = input<Permission[]>([]);
  showTitleInfoIcon = input(false);
  titleInfoDialogTitle = input('Page details');

  showSecondaryButton = input(false);
  secondaryButtonText = input('Secondary');
  secondaryButtonIcon = input<string>();
  secondaryButtonVariant = input<'Primary' | 'Secondary'>('Secondary');
  secondaryButtonSize = input<'Small' | 'Regular' | 'Large'>('Small');
  disabledSecondaryButton = input(false);
  secondaryPermissions = input<Permission[]>([]);

  breakPointService = inject(BreakpointService);
  isMobile = this.breakPointService.isMobile;

  showButtonTextOnMobile = input<{
    primary?: boolean;
    secondary?: boolean;
  }>({
    primary: false,
    secondary: false
  });

  showTextPrimaryButton = computed(
    () => !this.isMobile() || this.showButtonTextOnMobile().primary
  );
  showTextSecondaryButton = computed(
    () => !this.isMobile() || this.showButtonTextOnMobile().secondary
  );

  buttonClick = output<void>();
  secondaryButtonClick = output<void>();
  isTitleInfoDialogOpen = signal(false);

  onButtonClick(): void {
    this.buttonClick.emit();
  }

  onSecondaryButtonClick(): void {
    this.secondaryButtonClick.emit();
  }

  openTitleInfoDialog(): void {
    this.isTitleInfoDialogOpen.set(true);
  }

  closeTitleInfoDialog(): void {
    this.isTitleInfoDialogOpen.set(false);
  }
}
